import { render } from "./sidebar-link.vue?vue&type=template&id=1cd802ed"
import script from "./sidebar-link.vue?vue&type=script&lang=js"
export * from "./sidebar-link.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vendor/wielink-application/shared/resources/vue/layouts/partials/sidebar-link.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1cd802ed"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1cd802ed', __exports__)) {
    console.log('reload')
    api.reload('1cd802ed', __exports__)
  }
  
  module.hot.accept("./sidebar-link.vue?vue&type=template&id=1cd802ed", () => {
    console.log('re-render')
    api.rerender('1cd802ed', render)
  })

}


export default __exports__